import React from 'react';
import { render } from 'react-dom';
import './index.css';
import App from './App';
import { HardwareProvider } from './context/HardwareContext';

render(
    <HardwareProvider>
        <App />
    </HardwareProvider>,
    document.getElementById('root')
);
